<template>
  <footer class="cv-footer">

    <div class="cv-footer__disclaimer">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h6>Disclaimer</h6>
            <ul>
              <li>The Course Visualiser assists with the generation of a Course Plan. It should not be enacted until it is validated with the Academic Chair of
                the Course.</li>
              <li>This Course Plan is based on the course structure and offerings of latest Approved Courses only. It is the responsibility of students to
                ensure the correct availability of units in each semester/trimester of each academic year.</li>
              <li>Please contact the Academic Chair of the Course if you have any queries relating to the Course Plan.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="cv-footer__top">
      <div class="container">
        <div class="row">
          <div class="cv-footer__top-left">
            <div class="cv-footer__top-logo">
              <img :src="logo" alt="Murdoch University logo" />
            </div>
            <div class="cv-footer__social-links">
              <a href="https://goto.murdoch.edu.au/Facebook" target="_blank"><i class="fab fa-facebook"></i></a>
              <a href="https://goto.murdoch.edu.au/Twitter" target="_blank"><i class="fab fa-twitter"></i></a>
              <a href="https://goto.murdoch.edu.au/Instagram" target="_blank"><i class="fab fa-instagram"></i></a>
              <a href="https://goto.murdoch.edu.au/Youtube" target="_blank"><i class="fab fa-youtube"></i></a>
            </div>
          </div>
          <div class="cv-footer__top-right">
            <h6>Acknowledgment of Country</h6>
            <p>We acknowledge the Whadjuk people of the Noongar nation as the traditional custodians of this country and its waters and that Murdoch University
              stands on Noongar country. We pay our respects to Noongar elders past and present, and acknowledge their wisdom and advice in our teaching and
              cultural knowledge activities.</p>
            <a href="https://goto.murdoch.edu.au/Kulbardi" target="_blank" class="link-highlight">Find out more about our commitment to the Aboriginal and
              Torres Strait Islander community.</a>
          </div>
        </div>
      </div>
    </div>

    <div class="cv-footer__bottom">
      <div class="container">
        <div class="row">
          <div class="cv-footer__bottom-left">
            <h5 class="cv-footer__title"><span class="mr-2">{{ title }}</span></h5>
            <div class="cv-footer__version">{{ appVersion }}</div>
            <!-- <a href="http://goto.murdoch.edu.au/" target="_blank"><span class="far fa-external-link-alt"></span>© Murdoch University</a> -->
          </div>
          <div class="cv-footer__bottom-right">
            <div class="cv-footer__links">
              <a href="http://goto.murdoch.edu.au/" target="_blank"><span class="far fa-external-link-alt"></span>© Murdoch University</a>
              <a href="http://goto.murdoch.edu.au/TEQSANumber" target="_blank"><span class="far fa-external-link-alt"></span>TEQSA number: PRV12163</a>
              <a href="http://goto.murdoch.edu.au/CRICOSCode" target="_blank"><span class="far fa-external-link-alt"></span>CRICOS Code: 00125</a>
              <a href="http://goto.murdoch.edu.au/CopyrightNotice" target="_blank"><span class="far fa-external-link-alt"></span>Copyright &amp;
                Disclaimer</a>
              <a href="http://goto.murdoch.edu.au/Privacy" target="_blank"><span class="far fa-external-link-alt"></span>Privacy</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import muLogoGrass from '../../images/mu-logo-grass.png'

export default {
  data() {
    return {
      logo: muLogoGrass
    }
  },
  computed: {
    ...mapGetters({
      title: 'global/getTitle',
      appVersion: 'global/getAppVersion'
    })
  }
}
</script>
